module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo2024-ff05d703fcdd7f12b69907d242f2df5f.svg";